// src/components/Contact.js

import React from "react";

function Contact() {
  return (
    <section id="contact">
        <h2>Contact</h2>
        <p>Email: <a href="mailto:devguto@gmail.com" target="_blank" rel="noreferrer">
            devguto@gmail.com
        </a></p>
        <p>LinkedIn: <a href="https://linkedin.com/in/augustovicente" target="_blank" rel="noreferrer">
            https://linkedin.com/in/augustovicente
        </a></p>
        <p>Github: <a href="https://github.com/augustovicente" target="_blank" rel="noreferrer">
            https://github.com/augustovicente
        </a></p>
        <p>StackOverflow: <a href="https://stackoverflow.com/users/13384755/augusto-vicente" target="_blank" rel="noreferrer">
            https://stackoverflow.com/users/13384755/augusto-vicente
        </a></p>
        <p>Instagram: <a href="https://www.instagram.com/augustorvicente/" target="_blank" rel="noreferrer">
            https://www.instagram.com/augustorvicente/
        </a></p>
    </section>
  );
}

export default Contact;
